/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SpaProductAgeRestrictionDTO = {
    FROM_12_TO_16: 'FROM_12_TO_16',
    FROM_13_TO_INCLUDING_16: 'FROM_13_TO_INCLUDING_16',
    FROM_16: 'FROM_16',
    TO_INCLUDING_12: 'TO_INCLUDING_12',
    TO_16: 'TO_16',
    NONE: 'NONE'
} as const;
export type SpaProductAgeRestrictionDTO = typeof SpaProductAgeRestrictionDTO[keyof typeof SpaProductAgeRestrictionDTO];

